import { type Theme } from '@mui/material/styles';

export const getStatusColor = (percent: string, theme: Theme) => {
  const value = parseFloat(percent);
  if (isNaN(value)) return theme.palette.status.info;
  if (value > 75) return theme.palette.status.online;
  if (value > 50) return theme.palette.status.warning;
  return theme.palette.status.offline;
};

export const getLatencyThresholdColor = (val: string, theme: Theme): string => {
  const num = parseFloat(String(val).replace(/[^0-9.]/g, ''));
  if (isNaN(num) || val === 'N/A') return theme.palette.white['06'] || '#FFFFFF';
  if (num <= 30) return theme.palette.status.online || '#22C55E';
  if (num <= 70) return theme.palette.primary.main || '#00CFFF';
  if (num <= 150)
    return (
      theme.palette.warning?.main ||
      theme.palette.status.warning ||
      '#F59E0B'
    );
  return theme.palette.status.offline || '#EF4444';
};
